import * as React from "react";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger } from "./ui/dialog";
// import { Cross2Icon } from "@radix-ui/react-icons";
// import "../styles/dialog.style.css";

const ParticipantsDialog = ({ trigger= <></>, loading = false, participants = [] }) => (
    <Dialog>
        <DialogTrigger asChild>
            { trigger }
        </DialogTrigger>
        <DialogContent className="DialogContent participants-dialog" >
            <DialogTitle className="DialogTitle">Participants</DialogTitle>
            <DialogDescription className="DialogDescription">
                List of all participant verified/not verified.
            </DialogDescription>

            <DialogDescription className={"overflow-auto"}>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <div className="table-outer-mobile-margin">
                        <div
                            className="admin-table-container"
                            style={{
                                background: "#18181b",
                                border: "1px solid #39393b",
                                borderRadius: 6,
                                padding: 0,
                                marginBottom: 40,
                                boxShadow: "0 8px 32px rgba(0,0,0,0.20)",
                                overflowX: "auto",
                                width: "100%",
                                minWidth: 0,
                                maxWidth: "100%",
                            }}
                        >
                            <table
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    color: "#fff",
                                    fontSize: 15,
                                    minWidth: 650,
                                }}
                            >
                                <thead>
                                    <tr style={{ background: "#232325" }}>
                                        <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Name
                                        </th>
                                        <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Phone
                                        </th>
                                        <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Email
                                        </th>
                                        <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Registration ID
                                        </th>
                                        <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Attended
                                        </th>
                                        <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Registered Time
                                        </th>
                                        {/* <th
                                            style={{
                                                padding: 10,
                                                fontWeight: 600,
                                                textAlign: "center",
                                            }}
                                        >
                                            Attendance Time
                                        </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(participants) && participants.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan={5}
                                                style={{
                                                    color: "#aaa",
                                                    textAlign: "center",
                                                    padding: 14,
                                                }}
                                            >
                                                No participants found.
                                            </td>
                                        </tr>
                                    )}
                                    {Array.isArray(participants) &&
                                        participants.map((p) => (
                                            <tr
                                                key={p.registrationId}
                                                style={{
                                                    background: p.attended ? "#fff" : "transparent",
                                                    color: p.attended ? "#000" : "#transparent",
                                                    textWrap: "nowrap"
                                                }}
                                            >
                                                <td style={{ padding: 8, textAlign: "center" }}>
                                                    {p.name}
                                                </td>
                                                <td style={{ padding: 8, textAlign: "center" }}>
                                                    {p.phone}
                                                </td>
                                                <td style={{ padding: 8, textAlign: "center" }}>
                                                    {p.email}
                                                </td>
                                                <td style={{ padding: 8, textAlign: "center", textWrap: "nowrap" }}>
                                                    {p.registrationId}
                                                </td>
                                                <td style={{ padding: 8, textAlign: "center" }}>
                                                    {p.attended ? "Yes" : "No"}
                                                </td>
                                                <td style={{ padding: 8, textAlign: "center", textWrap: "nowrap" }}>
                                                    {p.createdAt
                                                        ? new Date(p.createdAt).toLocaleString()
                                                        : ""}
                                                </td>
                                                {/* <td style={{ padding: 8, textAlign: "center" }}>
                                                    {p.attendanceTime
                                                        ? new Date(p.attendanceTime).toLocaleString()
                                                        : ""}
                                                </td> */}
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

            </DialogDescription>


            <DialogClose asChild>
                <button className="IconButton" aria-label="Close">
                    {/* <Cross2Icon /> */}
                </button>
            </DialogClose>
        </DialogContent>
    </Dialog>
);

export default ParticipantsDialog;
